module.exports = __webpack_public_path__ + "img/CompScope_Space_10.c0d057a2.png";